import { Component, Prop } from 'vue-property-decorator'
import Vue from '@src/vue'
import { CreateElement } from 'vue'

import { Button } from '@src/elements/button/button'
import { ContentBox } from '@src/elements/content-box/content-box'
import EventBus from '@src/lib/event_bus'

import './body-measurements-card.sass'
import SessionManager from '@src/lib/session_manager'

@Component
export class BodyMeasurementsCard extends Vue {

  @Prop({ required: false })
  type: 'weight-goals' | 'circumferences-goals' | 'bmi'

  constructor () {
    super()
  }

  onSave () {
    EventBus.trigger('applyMeasurementsChange', this.type)
  }

  render (h: CreateElement) {
    return <ContentBox class='measurements-wrapper'>
      <div slot='content'>
        <div class='left'>
          {this.$slots.left}
        </div>

        <div class='right'>
          {this.$slots.right}
        </div>

        {this.$slots.default}
      </div>

      { (this.type === 'weight-goals' || this.type === 'circumferences-goals' || this.type === 'bmi') && SessionManager.Instance.isManager() ?
        <div slot='bottom'>
          <Button ref='saveBtn' label={this.$t('SAVE')} click={this.onSave} type='elevated' />
        </div> : null}
    </ContentBox>
  }
}
